// Module
var code = `<h4 translate>Instructions</h4> <p> <translate>Bring your payment of</translate> {{currentRegistration.remainingBalance | localizedCurrency:conference.currency.currencyCode}} <translate>to the event.</translate> </p> `;
// Exports
var _module_exports =code;;
var path = '/views/paymentMethods/payOnSite.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;